// Generated by Melange

import * as Buhta_cabinet__CalendarDatePicker from "./DatePicker/CalendarDatePicker.js";
import * as Buhta_cabinet__Dropdown from "../html/Dropdown.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(value) {
  return function (onPicked) {
    return function (alignOpt) {
      const align = alignOpt !== undefined ? alignOpt : "TopLeft";
      return function (className) {
        return function (backgroundOpt) {
          const background = backgroundOpt !== undefined ? backgroundOpt : "bg-white";
          return function (shadowOpt) {
            const shadow = shadowOpt !== undefined ? shadowOpt : false;
            return function (displayIconOpt) {
              const displayIcon = displayIconOpt !== undefined ? displayIconOpt : true;
              return function (labelOpt) {
                const label = labelOpt !== undefined ? labelOpt : "";
                return function (tillCurrentDateOpt) {
                  const tillCurrentDate = tillCurrentDateOpt !== undefined ? tillCurrentDateOpt : false;
                  return function (displayCurrentDateOpt) {
                    const displayCurrentDate = displayCurrentDateOpt !== undefined ? displayCurrentDateOpt : true;
                    return function (isBirthDayOpt) {
                      const isBirthDay = isBirthDayOpt !== undefined ? isBirthDayOpt : false;
                      return function (tillExactYearOpt, param) {
                        const tillExactYear = tillExactYearOpt !== undefined ? tillExactYearOpt : 2035;
                        const match = React.useState(function () {
                              return false;
                            });
                        const setIsDropdownShown = match[1];
                        const isDropdownShown = match[0];
                        const activator = function (param) {
                          return JsxRuntime.jsxs("div", {
                                      children: [
                                        label !== "" ? JsxRuntime.jsx("label", {
                                                children: label,
                                                className: Cn.$plus("absolute -top-[8px] left-[9px] px-2 text-asphalt transition-transform ease-in-out duration-250 bg-white", isDropdownShown || value !== "" ? "text-preheader translate-y-0" : "text-sm translate-y-[18px]")
                                              }) : null,
                                        JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      children: value === "" ? null : value
                                                    }),
                                                displayIcon ? (
                                                    isDropdownShown ? JsxRuntime.jsx("img", {
                                                            className: "w-5 h-5",
                                                            alt: "date",
                                                            src: StaticAsset.src("/static/icons/calendar-links.svg")
                                                          }) : JsxRuntime.jsx("img", {
                                                            className: "w-5 h-5",
                                                            alt: "date",
                                                            src: StaticAsset.src("/static/icons/calendar.svg")
                                                          })
                                                  ) : null
                                              ],
                                              className: Cn.$plus(Cn.$plus("flex justify-between items-center px-4 w-full py-[11px] border border-gray-main paragraph rounded focus:outline-none transition ease-in-out duration-150", background), Cn.on("border-links", isDropdownShown)),
                                              type: "button"
                                            })
                                      ],
                                      className: Cn.$plus(Cn.$plus("flex rounded-md relative", Cn.on("shadow-sm", shadow)), Cn.take(className))
                                    });
                        };
                        return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                                    className: "grow",
                                    innerClassName: "!min-w-0 mt-1",
                                    align: align,
                                    activator: activator,
                                    background: background,
                                    isDropdownShown: isDropdownShown,
                                    setIsDropdownShown: setIsDropdownShown,
                                    children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePicker.make, {
                                          onPicked: (function (value) {
                                              Curry._1(setIsDropdownShown, (function (param) {
                                                      return false;
                                                    }));
                                              Curry._1(onPicked, value);
                                            }),
                                          tillCurrentDate: tillCurrentDate,
                                          displayCurrentDate: displayCurrentDate,
                                          isBirthDay: isBirthDay,
                                          tillExactYear: tillExactYear
                                        })
                                  });
                      };
                    };
                  };
                };
              };
            };
          };
        };
      };
    };
  };
}

function CalendarDatePickerInput(Props) {
  return Curry.app(make(Props.value)(Props.onPicked), [
              Props.align,
              Props.className,
              Props.background,
              Props.shadow,
              Props.displayIcon,
              Props.label,
              Props.tillCurrentDate,
              Props.displayCurrentDate,
              Props.isBirthDay,
              Props.tillExactYear,
              undefined
            ]);
}

const make$1 = CalendarDatePickerInput;

export {
  make$1 as make,
}
/* Buhta_cabinet__CalendarDatePicker Not a pure module */
